import { render, staticRenderFns } from "./EditViewTermReports.vue?vue&type=template&id=1251ca75&scoped=true"
import script from "./EditViewTermReports.vue?vue&type=script&lang=js"
export * from "./EditViewTermReports.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReports.vue?vue&type=style&index=0&id=1251ca75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251ca75",
  null
  
)

export default component.exports